export const COUNTRIES = [
  { code: "IN", name: "India", dial: "91", flag: "🇮🇳" },
  { code: "US", name: "United States", dial: "1", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", dial: "44", flag: "🇬🇧" },
  { code: "AE", name: "UAE", dial: "971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial: "966", flag: "🇸🇦" },
  { code: "PK", name: "Pakistan", dial: "92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", dial: "880", flag: "🇧🇩" },
  { code: "NP", name: "Nepal", dial: "977", flag: "🇳🇵" },
  { code: "LK", name: "Sri Lanka", dial: "94", flag: "🇱🇰" },
  { code: "SG", name: "Singapore", dial: "65", flag: "🇸🇬" },
  { code: "MY", name: "Malaysia", dial: "60", flag: "🇲🇾" },
  { code: "AU", name: "Australia", dial: "61", flag: "🇦🇺" },
  { code: "CA", name: "Canada", dial: "1", flag: "🇨🇦" },
  { code: "NG", name: "Nigeria", dial: "234", flag: "🇳🇬" },
  { code: "ZA", name: "South Africa", dial: "27", flag: "🇿🇦" },
  { code: "PH", name: "Philippines", dial: "63", flag: "🇵🇭" },
  { code: "ID", name: "Indonesia", dial: "62", flag: "🇮🇩" },
  { code: "BR", name: "Brazil", dial: "55", flag: "🇧🇷" },
  { code: "RU", name: "Russia", dial: "7", flag: "🇷🇺" },
  { code: "DE", name: "Germany", dial: "49", flag: "🇩🇪" },
];
